import { ProductPageData } from '../../ApolloProvider/resolvers/Query/Product/ProductPage'
import {
  ProductPageQuery,
  ResolverVariantFieldsFragment,
} from '../../generated/graphql'

const PROVENANCE_OUTPUT_KEYS = {
  isProvenanceEnabled: 'enabled',
  provTransparencyText: 'textItem',
}

const getContentValue = (
  value: NonNullable<ProductPageQuery['product']>['content'][0]['value'],
): string => {
  switch (value.__typename) {
    case 'ProductContentRichContentListValue':
      return value.richContentListValue[0].content[0].content
    case 'ProductContentRichContentValue':
      return value.richContentValue.content[0].content
    case 'ProductContentStringListValue':
      return value.stringListValue[0]
    case 'ProductContentStringValue':
      return value.stringValue
    default:
      return ''
  }
}

export type DescriptionKeys = {
  items: string[]
  details: string[]
  download: string[]
  video: string[]
}

export const productDescription = (
  product:
    | ProductPageQuery['product']
    | ResolverVariantFieldsFragment['product'],
  productDescriptionKeys: DescriptionKeys,
): ProductPageData['description'] => {
  if (!product?.content) {
    return null
  }

  const values = product.content.reduce<
    NonNullable<ProductPageData['description']>
  >(
    (accumulator, content) => {
      if (
        content.key === 'isProvenanceEnabled' &&
        content.value['stringListValue'][0] === 'TRUE'
      ) {
        accumulator.provenance[PROVENANCE_OUTPUT_KEYS[content.key]] = true
      } else if (
        content.key === 'provTransparencyText' &&
        content.value['richContentValue'].content[0].content
      ) {
        accumulator.provenance[PROVENANCE_OUTPUT_KEYS[content.key]] =
          content.value['richContentValue'].content[0].content
      } else if (productDescriptionKeys.items.includes(content.key)) {
        accumulator.items.push({
          key: content.key,
          titleKey: content.key.toLowerCase(),
          content: getContentValue(content.value),
          __typename: 'ProductDescriptionItem',
        })
      } else if (productDescriptionKeys?.details.includes(content.key)) {
        accumulator.details.push({
          key: content.key,
          titleKey: content.key.toLowerCase(),
          value: getContentValue(content.value),
          __typename: 'ProductDescriptionDetail',
        })
      } else if (
        productDescriptionKeys?.video.includes(content.key) &&
        accumulator[content.key] === null
      ) {
        accumulator[content.key] = getContentValue(content.value)
      }

      return accumulator
    },
    {
      items: [],
      details: [],
      videoTitle: null,
      videoReference: null,
      deliveryTitle: null,
      provenance: {
        enabled: false,
        textItem: null,
        __typename: 'ProductDescriptionProvenance',
      },
      __typename: 'ProductDescription',
    },
  )

  const productDescriptionItemKeys = productDescriptionKeys.items || []

  values.items.sort((itemA, itemB) =>
    productDescriptionItemKeys.indexOf(itemA.key) >
    productDescriptionItemKeys.indexOf(itemB.key)
      ? 1
      : productDescriptionItemKeys.indexOf(itemB.key) >
        productDescriptionItemKeys.indexOf(itemA.key)
      ? -1
      : 0,
  )

  return values
}
